import { ContentState, convertFromHTML, convertToRaw, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import React, { useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const HTMLEditor = ({
  toolbar = undefined,
  toolbarHidden = true,
  editorStyle = {},
  value,
  onEdit,
  disabled = false,
  editorClassName,
  ...props
}: any) => {
  const sanitizeHtml = (html: string) => {
    return html.replace(/<ins>/g, '<u>').replace(/<\/ins>/g, '</u>');
  };

  const createEditorState = (value: string) => {
    const cleanHtml = sanitizeHtml(value || '');
    const blocksFromHTML = convertFromHTML(cleanHtml);
    const contentState = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);
    return EditorState.createWithContent(contentState);
  };

  const [editorState, setEditorState] = useState<EditorState | null>(createEditorState(value));

  const onChange = async (newState: any) => {
    if (disabled) return;
    setEditorState(newState);
  };

  const newValue = draftToHtml(convertToRaw(editorState!.getCurrentContent()));

  return (
    <Editor
      editorStyle={editorStyle}
      toolbarHidden={toolbarHidden}
      editorState={editorState}
      editorClassName={editorClassName}
      onEditorStateChange={onChange}
      onBlur={() => onEdit(newValue)}
      toolbar={toolbar}
      readOnly={disabled}
      {...props}
    />
  );
};

export default HTMLEditor;
